import { create } from "zustand";
import type { StaffWorkday } from "../types";

interface StaffWorkdayState {
	modalOpen: boolean;
	editingItem: StaffWorkday | null;
}

interface StaffWorkdayActions {
	openCreateModal: () => void;
	openEditModal: (item: StaffWorkday) => void;
	onOpen: (item?: StaffWorkday) => void;
	closeModal: () => void;
}

type StaffWorkdayStore = StaffWorkdayState & StaffWorkdayActions;

export const useStaffWorkdayStore = create<StaffWorkdayStore>((set) => ({
	modalOpen: false,
	editingItem: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingItem: null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	onOpen: (item) => {
		set({ modalOpen: true, editingItem: item ?? null });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null });
	},
}));
